"use client";
import React from "react";
import EventPopup from "~components/event/EventPopup";
import AddCartPopup from "~components/cart/AddCartPopup";
import OrderStatusPopup from "~components/orders/OrderStatusPopup";
import CartErrorPopup from "@/app/cart/_components/shopCart/shopCartPopup/CartErrorPopup";
import SystemCartErrorPopup from "@/app/cart/_components/shopCart/shopCartPopup/SystemCartErrorPopup";
import PopupSendMail from "~components/product/PopupSendMail";

export default function PopupsPage() {
	return (
		<>
			<AddCartPopup />
			<CartErrorPopup />
			<OrderStatusPopup />
			<EventPopup />
			<SystemCartErrorPopup />
			<PopupSendMail />
			{/* <ProductVariantPopup /> */}
		</>
	);
}
